// Custom code to hide all countries except Canada and US in the currency/country selector
document.addEventListener('DOMContentLoaded', function() {
    // Function to filter countries
    function filterCountries() {
      var countryListItems = document.querySelectorAll('country-selector .custom-select__listbox li');
      
      countryListItems.forEach(function(item) {
        var countryCode = item.getAttribute('data-value');
        if (countryCode !== 'CA' && countryCode !== 'US') {
          item.style.display = 'none';
        }
      });
    }
  
    // Run the filter function once after DOM content is loaded
    setTimeout(filterCountries, 1000); // Adjust the delay as necessary
  
    // Attach a MutationObserver to the dropdown menu to filter countries when content changes
    var listbox = document.querySelector('country-selector .custom-select__listbox');
    if (listbox) {
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length > 0) {
            filterCountries();
          }
        });
      });
  
      observer.observe(listbox, { childList: true, subtree: true });
    }
  
    // Optionally, you can also attach an event listener to the dropdown trigger to ensure it's filtered when clicked
    var dropdown = document.querySelector('.country-selector .custom-select__trigger');
    if (dropdown) {
      dropdown.addEventListener('click', function() {
        setTimeout(filterCountries, 100); // Small delay to ensure items are rendered
      });
    }
  
    /*
     * =======================================
     * US Visitors Auto-Switch to USD (One-Time)
     * =======================================
     * Auto-switches to USD once for US visitors and shows a small toast with undo.
     */
    const usdAutoSwitchKeys = {
      done: 'sanction-usd-auto-switch-done',
      optOut: 'sanction-usd-auto-switch-opt-out',
      toast: 'sanction-usd-auto-switch-toast'
    };
  
    function getLocalizationForm() {
      return document.querySelector('form.localization');
    }
  
    function getCountryInput(form) {
      return form ? form.querySelector('input[name="country_code"]') : null;
    }
  
    function submitCountryCode(countryCode) {
      const form = getLocalizationForm();
      const input = getCountryInput(form);
      if (!form || !input) return false;
      input.value = countryCode;
      form.submit();
      return true;
    }
  
    function canUseStorage(storage) {
      try {
        const testKey = '__storage_test__';
        storage.setItem(testKey, '1');
        storage.removeItem(testKey);
        return true;
      } catch (e) {
        return false;
      }
    }
  
    function getSessionUSFlag() {
      if (!canUseStorage(sessionStorage)) return null;
      const checked = sessionStorage.getItem('us-visitor-checked');
      if (!checked) return null;
      return sessionStorage.getItem('is-us-visitor') === 'true';
    }
  
    function checkBrowserIndicators() {
      try {
        const browserLocale = (navigator.language || navigator.userLanguage || '').toLowerCase();
        const timezone = (Intl.DateTimeFormat().resolvedOptions().timeZone || '').toLowerCase();
        const isUSLocale = browserLocale === 'en-us' || browserLocale.startsWith('en-us-');
        const canadianTimezones = [
          'toronto', 'vancouver', 'winnipeg', 'edmonton', 'regina', 'halifax',
          'st_johns', 'yellowknife', 'whitehorse', 'dawson', 'montreal', 'ottawa',
          'thunder_bay', 'iqluit'
        ];
        const isUSTimezone = timezone.startsWith('america/') &&
          !canadianTimezones.some(city => timezone.includes(city));
        return isUSTimezone || (isUSLocale && isUSTimezone);
      } catch (e) {
        return false;
      }
    }
  
    function detectUSVisitor() {
      return new Promise((resolve) => {
        const sessionFlag = getSessionUSFlag();
        if (sessionFlag !== null) {
          resolve(sessionFlag);
          return;
        }
  
        let resolved = false;
        const finish = (value) => {
          if (resolved) return;
          resolved = true;
          resolve(value);
        };
  
        const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
        // If IP check doesn't complete in time, default to NOT US.
        // It's better to miss auto-switching for a US visitor than to
        // incorrectly switch a Canadian visitor to USD.
        const timeoutId = setTimeout(() => finish(false), 1500);
  
        fetch('https://ipapi.co/json/', controller ? { signal: controller.signal } : {})
          .then((response) => {
            if (!response.ok) throw new Error('Geo lookup failed');
            return response.json();
          })
          .then((data) => {
            clearTimeout(timeoutId);
            const isUS = data && data.country_code === 'US';
            finish(isUS);
          })
          .catch(() => {
            clearTimeout(timeoutId);
            // If IP check fails, default to NOT US - never guess
            finish(false);
          });
      });
    }
  
    function showCurrencyToast(previousCountryCode) {
      if (document.querySelector('.currency-toast')) return;
  
      const toast = document.createElement('div');
      toast.className = 'currency-toast currency-toast--hidden';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML = `
        <div class="currency-toast__content">
          <div class="currency-toast__title">Switched to USD 🇺🇸</div>
          <div class="currency-toast__text">Prices now shown in US dollars.</div>
        </div>
        <div class="currency-toast__actions">
          <button type="button" class="currency-toast__undo">Undo</button>
          <button type="button" class="currency-toast__close" aria-label="Dismiss">✕</button>
        </div>
      `;
  
      const closeToast = () => {
        toast.classList.add('currency-toast--dismissed');
        setTimeout(() => toast.remove(), 300);
      };
  
      const undoButton = toast.querySelector('.currency-toast__undo');
      const closeButton = toast.querySelector('.currency-toast__close');
  
      undoButton.addEventListener('click', () => {
        if (canUseStorage(localStorage)) {
          localStorage.setItem(usdAutoSwitchKeys.optOut, 'true');
          localStorage.removeItem(usdAutoSwitchKeys.toast);
        }
        if (previousCountryCode) {
          submitCountryCode(previousCountryCode);
        }
        closeToast();
      });
  
      closeButton.addEventListener('click', () => {
        if (canUseStorage(localStorage)) {
          localStorage.removeItem(usdAutoSwitchKeys.toast);
        }
        closeToast();
      });
  
      document.body.appendChild(toast);
      requestAnimationFrame(() => toast.classList.remove('currency-toast--hidden'));
  
      setTimeout(() => {
        if (document.body.contains(toast)) {
          closeToast();
        }
      }, 8000);
    }
  
    function maybeShowPostSwitchToast() {
      if (!canUseStorage(localStorage)) return;
      const toastData = localStorage.getItem(usdAutoSwitchKeys.toast);
      if (!toastData) return;
      let data = null;
      try {
        data = JSON.parse(toastData);
      } catch (e) {
        localStorage.removeItem(usdAutoSwitchKeys.toast);
        return;
      }
      localStorage.removeItem(usdAutoSwitchKeys.toast);
      showCurrencyToast(data && data.previousCountryCode);
    }
  
    function maybeAutoSwitchToUSD() {
      if (!canUseStorage(localStorage)) return;
      if (localStorage.getItem(usdAutoSwitchKeys.done) === 'true') return;
      if (localStorage.getItem(usdAutoSwitchKeys.optOut) === 'true') return;
  
      const form = getLocalizationForm();
      const input = getCountryInput(form);
      if (!form || !input) return;
      const currentCountry = input.value;
      if (currentCountry === 'US') {
        detectUSVisitor().then((isUS) => {
          if (!isUS) return;
          if (localStorage.getItem(usdAutoSwitchKeys.done) === 'true') return;
          localStorage.setItem(usdAutoSwitchKeys.done, 'true');
          showCurrencyToast('CA');
        });
        return;
      }
  
      detectUSVisitor().then((isUS) => {
        if (!isUS) return;
        const switched = submitCountryCode('US');
        if (switched) {
          localStorage.setItem(usdAutoSwitchKeys.done, 'true');
          localStorage.setItem(
            usdAutoSwitchKeys.toast,
            JSON.stringify({ previousCountryCode: currentCountry })
          );
        }
      });
    }
  
    function markCurrencyDecisionMade() {
      if (!canUseStorage(localStorage)) return;
      try {
        localStorage.setItem(usdAutoSwitchKeys.done, 'true');
      } catch (e) {}
    }

    // Any explicit click on the country selector is final — record it before
    // the form submits so the auto-switch can't undo the user's choice on the
    // next page load. Capture phase so we run before the form's own submit handler.
    function attachLocalizationFormListener() {
      const form = getLocalizationForm();
      if (!form) return;
      form.addEventListener('change', markCurrencyDecisionMade, true);
    }

    attachLocalizationFormListener();
    maybeShowPostSwitchToast();
    maybeAutoSwitchToUSD();
    
    /*
     * =======================================
     * Free Grip Tooltip Functionality
     * =======================================
     * This code handles the "Free Grip" tooltip on skateboard deck product pages.
     * The tooltip displays "Grip tape only, not applied to board" to clarify
     * that customers receive the grip tape separately, not pre-applied.
     * 
     * - On desktop: Tooltip appears on hover
     * - On mobile: Tooltip toggles on tap/click
     */
    
    // Find all tooltip elements on the page
    const tooltipWrappers = document.querySelectorAll('.tooltip-wrapper');
    
    if (tooltipWrappers.length > 0) {
      tooltipWrappers.forEach(wrapper => {
        // Add touchstart event for mobile devices
        wrapper.addEventListener('touchstart', function(e) {
          if (window.innerWidth <= 767) {
            e.preventDefault();
            this.classList.toggle('mobile-tooltip-active');
            e.stopPropagation();
          }
        });
        
        // Add click event for all devices
        wrapper.addEventListener('click', function(e) {
          if (window.innerWidth <= 767) {
            e.preventDefault();
            this.classList.toggle('mobile-tooltip-active');
            e.stopPropagation();
          }
        });
      });
      
      // Close tooltips when clicking elsewhere on the page
      document.addEventListener('click', function(event) {
        tooltipWrappers.forEach(tooltip => {
          if (!tooltip.contains(event.target)) {
            tooltip.classList.remove('mobile-tooltip-active');
          }
        });
      });
      
      // Close tooltips when touching elsewhere on mobile
      document.addEventListener('touchstart', function(event) {
        tooltipWrappers.forEach(tooltip => {
          if (!tooltip.contains(event.target)) {
            tooltip.classList.remove('mobile-tooltip-active');
          }
        });
      }, { passive: true });
    }
  });

  // Remove the parent of "custom-accordion" so that we can add metafield images into the accordion on product pages using "custom liquid" section
  (function() {
    var parents = [];
    document.querySelectorAll('.custom-accordion').forEach(function(el) {
      var parent = el.parentElement;
      if (parent && parents.indexOf(parent) === -1) parents.push(parent);
    });
    parents.forEach(function(parent) {
      parent.replaceWith.apply(parent, Array.prototype.slice.call(parent.childNodes));
    });
  })();

  // Turn visible text into a safe class name: lowercase, strip non-word
  // characters (except spaces/dashes), spaces become dashes.
  function sanctionSlugifyText(text) {
    return text
      .toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-');
  }

  // Create class for nav items based on inner text titles
  document.querySelectorAll('.navigation__link').forEach(function(link) {
    var className = sanctionSlugifyText(link.textContent);
    if (className) link.classList.add(className);
  });

  function addClassesToLabels() {
    var labels = document.querySelectorAll('.not-in-quickbuy .label');
    if (labels.length) {
      labels.forEach(function(label) {
        var className = sanctionSlugifyText(label.textContent);
        if (className) label.classList.add(className);
      });
    } else {
      setTimeout(addClassesToLabels, 100); // Retry after 100ms if elements aren't present yet
    }
  }

  document.addEventListener('DOMContentLoaded', addClassesToLabels);


  // Inject Link to All Brands Under Logos
  document.addEventListener('DOMContentLoaded', function() {
  const target = document.querySelector('.section-logo-list h2.hometitle');
  
  // Only proceed if the target element exists
  if (target) {
    // Create the new <a> element
    const link = document.createElement('a');
    link.className = 'small-feature-link brands-all-link';
    link.href = '/pages/brands';
    link.textContent = 'View all';
  
    // Insert the link immediately after the <h2>
    target.insertAdjacentElement('afterend', link);
  }
  });

  // Replace Question Mark with AI Sparkle Icon on Product Page Collapsable Tabs
  const oldSvg = document.querySelector('.icon--type-question_mark');
  
  if (oldSvg) {
    const newSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    newSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    newSvg.setAttribute('viewBox', '0 0 24 24');
    newSvg.setAttribute('fill', 'none');
    newSvg.setAttribute('stroke', 'currentColor');
    newSvg.setAttribute('stroke-width', '2');
    newSvg.setAttribute('stroke-linecap', 'round');
    newSvg.setAttribute('stroke-linejoin', 'round');
  
    // Copy width and height from the old SVG to the new one
    const width = oldSvg.getAttribute('width') || oldSvg.clientWidth || 16;
    const height = oldSvg.getAttribute('height') || oldSvg.clientHeight || 16;
    newSvg.setAttribute('width', width);
    newSvg.setAttribute('height', height);
  
    // Copy classes from old SVG
    newSvg.setAttribute('class', oldSvg.getAttribute('class'));
  
    // Add the new paths
    const path1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path1.setAttribute('stroke', 'none');
    path1.setAttribute('d', 'M0 0h24v24H0z');
    path1.setAttribute('fill', 'none');
  
    const path2 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path2.setAttribute('d', 'M16 18a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm0 -12a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm-7 12a6 6 0 0 1 6 -6a6 6 0 0 1 -6 -6a6 6 0 0 1 -6 6a6 6 0 0 1 6 6z');
  
    newSvg.appendChild(path1);
    newSvg.appendChild(path2);
  
    // Replace the old SVG with the new one
    oldSvg.replaceWith(newSvg);
  }
  // Make price only bold on the Services page
  document.addEventListener('DOMContentLoaded', function() {
      const elements = document.querySelectorAll('.disclosure__title');
  
      elements.forEach(element => {
          const text = element.innerText;
          const priceMatch = text.match(/\$\d+/); // Find the price part
          if (priceMatch) {
              const price = priceMatch[0];
              const newText = text.replace(price, `<span class="service-price">${price}</span>`);
              element.innerHTML = newText;
          }
      });
  });
  // This is special code that hides the shipping disclosure on the gift card product page
  document.addEventListener('DOMContentLoaded', function() {
    // Check if the product is a gift card
    const productDiv = document.querySelector('.product');
    
    if (productDiv) {
      // Function to hide the shipping disclosure
      function hideShippingDisclosure() {
        const disclosureTitles = document.querySelectorAll('.disclosure__title');
        disclosureTitles.forEach(title => {
          const withIconBeside = title.querySelector('.with-icon__beside');
          if (withIconBeside && withIconBeside.textContent.trim() === 'Shipping') {
            title.style.display = 'none';
          }
        });
      }
  
      // Check if the product title contains "Gift Card"
      const productTitle = document.querySelector('.product-title');
      if (productTitle && productTitle.textContent.toLowerCase().includes('gift card')) {
        hideShippingDisclosure();
        
        // If it didn't work, try again after a short delay
        setTimeout(hideShippingDisclosure, 500);
  
        // Also, observe for changes in the DOM
        const observer = new MutationObserver(hideShippingDisclosure);
        observer.observe(document.body, { childList: true, subtree: true });
      }
    }
  });
  // Inject Partners Section Under Sanction about section in the footer
  document.addEventListener('DOMContentLoaded', function() {
    // Inject "Proudly Partnered With" section under the Sanction block
    const sanctionColumn = document.querySelector('.section-footer__row__col.section-footer__text-block');
    
    if (sanctionColumn) {
        const partnersSection = document.createElement('div');
        partnersSection.className = 'section-footer__text-block';
        partnersSection.style.marginTop = '30px'; // Add some spacing between sections
        
        partnersSection.innerHTML = `
            <div class="section-footer__title heading-font h6 no-wrap">Proudly Partnered With</div>
            <div class="partners-logos" style="display: flex; align-items: center; gap: 28px; margin-top: 15px;">
               <a href="/pages/mount-st-louis-moonstone"><img src="https://cdn.shopify.com/s/files/1/0333/7009/files/logo-mslm.png?v=1732728255" alt="Mt. St. Louis Moonstone" style="height: 35px; width: auto;"></a>
               <a href="/pages/park-labs"><img src="https://cdn.shopify.com/s/files/1/0333/7009/files/logo-park-labs-footer-wide.png?v=1757609541" alt="Park Labs" style="height: 35px; width: auto;"></a>
               <a href="https://www.thesenders.co/" target="_blank"><img src="https://cdn.shopify.com/s/files/1/0333/7009/files/logo-senders-footer.png?v=1757609308" alt="Senders" style="height: 35px; width: auto;"></a>
            </div>
        `;
        
        sanctionColumn.appendChild(partnersSection);
    }
  
    // Inject brand logos beside the copyright text
    // const copyrightContainer = document.querySelector('.copyright');
  
    // if (copyrightContainer) {
    //     const brandLogos = document.createElement('div');
    //     brandLogos.className = 'footer-brand-logos';
    //     brandLogos.style.display = 'inline-flex';
    //     brandLogos.style.alignItems = 'center';
    //     brandLogos.style.gap = '10px';
    //     brandLogos.style.marginLeft = '20px'; // Add some space between text and logos
  
    //     brandLogos.innerHTML = `
    //         <img src="https://cdn.shopify.com/s/files/1/0333/7009/files/logo-mslm.png?v=1732728255" alt="Brand 4" style="height: 24px; width: auto;">
    //     `;
  
    //     copyrightContainer.appendChild(brandLogos);
    // }
  });
  // Secret Sale Coupon Reveal and Copy functionality
  document.addEventListener('DOMContentLoaded', function() {
    const blockCorner = document.querySelector('.block.corner');
    if (blockCorner) {
      blockCorner.addEventListener('click', function() {
        const revealCoupon = this.querySelector('.reveal-coupon');
        const card = this.closest('.card');
        const confirmationMessage = card.querySelector('.confirmation-message');
        const fireworks = document.querySelector('.fireworks');
        
        // 1. Change background to green
        this.style.backgroundColor = '#4CAF50';
        
        // 2. Replace SVG with new checkmark
        revealCoupon.querySelector('svg').outerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="24" height="24" stroke-width="2">
            <path d="M5 12l5 5l10 -10"></path>
          </svg>
        `;
        
        // 3 & 4. Hide the corner pseudo-elements by adding a class
        this.classList.add('revealed');
        
        // 5. Change the text content to HORSE26 + copied
        revealCoupon.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="24" height="24" stroke-width="2">
            <path d="M5 12l5 5l10 -10"></path>
          </svg>
          <strong>HORSE26</strong> <span style="font-weight: normal">coupon copied</span>
        `;
  
        // 6. Show confirmation message and expand card
        card.classList.add('expanded');
        confirmationMessage.classList.add('visible');
  
        // 7. Show fireworks
        if (fireworks) {
          fireworks.classList.add('show');
        }
  
        // Copy HORSE26 to clipboard
        navigator.clipboard.writeText('HORSE26').then(() => {
          console.log('Coupon code copied to clipboard');
        }).catch(err => {
          console.error('Failed to copy code: ', err);
        });
      });
    }
  });
  // Hide first hr.not-in-quickbuy when nothing visible between the two dividers
  // (no inventory warning, no free shipping, no video review link)
  function updateUnderPriceDivider() {
    const productForm = document.querySelector('.product-form');
    if (!productForm) return;

    const firstHr = productForm.querySelector('hr.not-in-quickbuy');
    if (!firstHr) return;

    const underPriceDivs = productForm.querySelectorAll('.under-price');
    let hasVisibleContent = false;

    underPriceDivs.forEach(function(div) {
      if (div.hidden || div.style.display === 'none') return;
      var infoBlock = div.querySelector('.product-info-block');
      // If there's a product-info-block, it must not be hidden
      if (infoBlock && !infoBlock.hidden) {
        hasVisibleContent = true;
      }
      // If no product-info-block but div has children, it's visible content
      if (!infoBlock && div.children.length > 0) {
        hasVisibleContent = true;
      }
    });

    firstHr.style.display = hasVisibleContent ? '' : 'none';
  }

  document.addEventListener('DOMContentLoaded', updateUnderPriceDivider);

  // Re-run after variant changes (inventory block gets replaced dynamically)
  document.addEventListener('on:variant:change', function() {
    setTimeout(updateUnderPriceDivider, 50);
  });
  /* ============================================
   * FOOTWEAR SIZE FILTER COLUMN INJECTION
   * ============================================
   * Injects a "By Size" column with a grid of size links
   * into the Footwear navigation dropdown, appearing between
   * the "All Shoes" and "More" columns.
   */
  document.addEventListener('DOMContentLoaded', function() {
    // Configuration: sizes to display in the grid
    const shoesSizes = [
      '4', '4.5', '5',
      '5.5', '6', '6.5',
      '7', '7.5', '8',
      '8.5', '9', '9.5',
      '10', '10.5', '11',
      '11.5', '12', '13',
      '14', '4.5/W6', '5.5/W7',
      '5/W6.5', '6.5/W8', '6/W7.5'
    ];
    
    // Base URL for size filter links
    const baseUrl = '/collections/shoes?filter.v.availability=1&filter.v.option.size=';
    const sortParam = '&sort_by=created-descending';
    
    function injectSizeColumn() {
      // Find the Footwear navigation item (both desktop and mobile)
      const footwearLinks = document.querySelectorAll('.navigation__link');
      
      footwearLinks.forEach(function(link) {
        const linkText = link.textContent.trim().toLowerCase();
        
        // Check if this is the Footwear link
        if (linkText === 'footwear') {
          const navItem = link.closest('.navigation__item');
          if (!navItem) return;
          
          // Find the tier-2 container and columns list
          const tier2Container = navItem.querySelector('.navigation__tier-2-container');
          if (!tier2Container) return;
          
          const columnsList = tier2Container.querySelector('.navigation__tier-2.navigation__columns');
          if (!columnsList) return;
          
          // Check if we've already injected the size column
          if (columnsList.querySelector('.navigation__column--by-size')) return;
          
          // Check if this is mobile navigation
          const isMobile = navItem.closest('.mobile-navigation-drawer') !== null;
          
          // Find the "MORE" column to insert before it
          const columns = columnsList.querySelectorAll('.navigation__column');
          let moreColumn = null;
          let allShoesColumn = null;
          
          columns.forEach(function(col) {
            const titleLink = col.querySelector('.navigation__column-title, .navigation__link');
            if (titleLink) {
              const titleText = titleLink.textContent.trim().toLowerCase();
              if (titleText === 'more') {
                moreColumn = col;
              }
              if (titleText === 'all shoes') {
                allShoesColumn = col;
              }
            }
          });
          
          // Create the size column
          const sizeColumn = document.createElement('li');
          
          if (isMobile) {
            // Mobile: Create a collapsible structure matching the theme exactly
            sizeColumn.className = 'navigation__item navigation__item--with-children navigation__column navigation__column--by-size';
            
            // Create the column title link (same structure as theme)
            const titleLink = document.createElement('a');
            titleLink.href = '/collections/shoes';
            titleLink.className = 'navigation__link navigation__column-title';
            titleLink.setAttribute('aria-haspopup', 'true');
            titleLink.setAttribute('aria-expanded', 'false');
            titleLink.textContent = 'By Size';
            
            // Create the toggle button (exact theme structure)
            const toggleBtn = document.createElement('a');
            toggleBtn.className = 'navigation__children-toggle';
            toggleBtn.href = '#';
            toggleBtn.setAttribute('aria-label', 'Show links');
            // Use exact same SVG as theme's icon-toggle-menu.liquid
            toggleBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-chevron-down" aria-hidden="true" focusable="false" role="presentation"><path d="m6 9 6 6 6-6"/></svg>';
            
            // Create the collapsible container (tier-3 style)
            const tier3Container = document.createElement('div');
            tier3Container.className = 'navigation__tier-3-container navigation__child-tier';
            
            // Create the size grid inside
            const sizeGrid = document.createElement('div');
            sizeGrid.className = 'nav-size-grid';
            
            // Create size links
            shoesSizes.forEach(function(size) {
              const sizeLink = document.createElement('a');
              sizeLink.href = baseUrl + encodeURIComponent(size) + sortParam;
              sizeLink.className = 'nav-size-grid__item';
              sizeLink.textContent = size;
              sizeGrid.appendChild(sizeLink);
            });
            
            tier3Container.appendChild(sizeGrid);
            
            // Assemble in same order as theme
            sizeColumn.appendChild(titleLink);
            sizeColumn.appendChild(toggleBtn);
            sizeColumn.appendChild(tier3Container);
            
            // Add toggle functionality (matching theme behavior)
            toggleBtn.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              const isOpen = sizeColumn.classList.contains('navigation__item--open');
              
              if (isOpen) {
                sizeColumn.classList.remove('navigation__item--open');
                titleLink.setAttribute('aria-expanded', 'false');
              } else {
                sizeColumn.classList.add('navigation__item--open');
                titleLink.setAttribute('aria-expanded', 'true');
              }
            });
            
          } else {
            // Desktop: Simple column layout
            sizeColumn.className = 'navigation__item navigation__column navigation__column--by-size';
            
            // Create the column title
            const titleLink = document.createElement('a');
            titleLink.href = '/collections/shoes';
            titleLink.className = 'navigation__link navigation__column-title';
            titleLink.textContent = 'By Size';
            
            // Create the size grid container
            const sizeGrid = document.createElement('div');
            sizeGrid.className = 'nav-size-grid';
            
            // Create size links
            shoesSizes.forEach(function(size) {
              const sizeLink = document.createElement('a');
              sizeLink.href = baseUrl + encodeURIComponent(size) + sortParam;
              sizeLink.className = 'nav-size-grid__item';
              sizeLink.textContent = size;
              sizeGrid.appendChild(sizeLink);
            });
            
            // Assemble the column
            sizeColumn.appendChild(titleLink);
            sizeColumn.appendChild(sizeGrid);
          }
          
          // Insert the column (after ALL SHOES, before MORE, or at the end)
          if (moreColumn) {
            columnsList.insertBefore(sizeColumn, moreColumn);
          } else if (allShoesColumn && allShoesColumn.nextSibling) {
            columnsList.insertBefore(sizeColumn, allShoesColumn.nextSibling);
          } else {
            // Insert before any promotion columns
            const promoColumn = columnsList.querySelector('.navigation__column--promotion');
            if (promoColumn) {
              columnsList.insertBefore(sizeColumn, promoColumn);
            } else {
              columnsList.appendChild(sizeColumn);
            }
          }
          
          // Update column count class on the parent
          updateColumnCount(columnsList);
        }
      });
    }
    
    function updateColumnCount(columnsList) {
      // Count non-promotion columns
      const nonPromoColumns = columnsList.querySelectorAll('.navigation__column:not(.navigation__column--promotion)');
      const totalColumns = columnsList.querySelectorAll('.navigation__column');
      
      // Remove existing count classes
      columnsList.className = columnsList.className.replace(/navigation__columns--count-\d+/g, '');
      columnsList.className = columnsList.className.replace(/navigation__columns--5-cols/g, '');
      columnsList.className = columnsList.className.replace(/navigation__columns--over-5-cols/g, '');
      
      // Add appropriate classes
      columnsList.classList.add('navigation__columns--count-' + totalColumns.length);
      if (nonPromoColumns.length === 5) {
        columnsList.classList.add('navigation__columns--5-cols');
      } else if (nonPromoColumns.length > 5) {
        columnsList.classList.add('navigation__columns--over-5-cols');
      }
    }
    
    // Inject the size grid CSS
    function injectSizeGridStyles() {
      if (document.getElementById('nav-size-grid-styles')) return;
      
      const styles = document.createElement('style');
      styles.id = 'nav-size-grid-styles';
      styles.textContent = `
        /* Nav Size Grid - Footwear Dropdown */
        
        /* Size grid styling */
        .nav-size-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 5px;
          margin-top: 8px;
          width: 200px;
        }
        
        .nav-size-grid__item {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 7px 2px;
          border: 1px solid #d5d5d5;
          border-radius: 3px;
          font-size: 11px;
          font-weight: 500;
          color: #444;
          text-decoration: none;
          background: #fff;
          transition: all 0.15s ease;
          white-space: nowrap;
          min-height: 30px;
        }
        
        .nav-size-grid__item:hover {
          border-color: #000;
          background: #000;
          color: #fff;
        }
        
        /* Mobile navigation drawer - By Size column */
        .mobile-navigation-drawer .navigation__column--by-size {
          padding: 0;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          width: 100%;
          position: relative;
        }
        
        .mobile-navigation-drawer .navigation__column--by-size > .navigation__link {
          flex: 1 1 0;
          max-width: calc(100% - 60px);
        }
        
        .mobile-navigation-drawer .navigation__column--by-size > .navigation__children-toggle {
          flex: 0 0 auto;
        }
        
        .mobile-navigation-drawer .navigation__column--by-size > .navigation__tier-3-container {
          flex-basis: 100%;
          padding: 0 20px;
          visibility: hidden;
          height: 0;
          opacity: 0;
          overflow: hidden;
        }
        
        .mobile-navigation-drawer .navigation__column--by-size.navigation__item--open > .navigation__tier-3-container {
          visibility: visible;
          height: auto;
          opacity: 1;
          padding: 5px 20px 20px;
        }
        
        .mobile-navigation-drawer .nav-size-grid {
          grid-template-columns: repeat(4, 1fr);
          gap: 8px;
          width: 100%;
          max-width: 100%;
        }
        
        .mobile-navigation-drawer .nav-size-grid__item {
          padding: 12px 6px;
          font-size: 14px;
          min-height: 44px;
          border-radius: 4px;
        }
        
        @media (max-width: 380px) {
          .mobile-navigation-drawer .nav-size-grid {
            grid-template-columns: repeat(3, 1fr);
          }
        }
      `;
      
      document.head.appendChild(styles);
    }
    
    // Run injection
    injectSizeGridStyles();
    injectSizeColumn();
    
    // Re-run on DOM changes (for dynamically loaded content)
    const observer = new MutationObserver(function(mutations) {
      let shouldInject = false;
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && (
              node.classList?.contains('navigation__tier-2-container') ||
              node.querySelector?.('.navigation__tier-2-container')
            )) {
              shouldInject = true;
            }
          });
        }
      });
      if (shouldInject) {
        injectSizeColumn();
      }
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
    
    // Also run after a delay to catch any late-loading content
    setTimeout(injectSizeColumn, 500);
    setTimeout(injectSizeColumn, 1500);
  });
  // Inject Instagram icon beside "From the 'Gram" heading
  document.addEventListener('DOMContentLoaded', function() {
    function injectInstagramIcon() {
      // Find all headings on the page
      const allHeadings = document.querySelectorAll('h1, h2, h3, h4, h5, h6');
      
      allHeadings.forEach(function(heading) {
        // Check if icon already exists to avoid duplicates
        if (heading.querySelector('.instagram-icon-injected')) {
          return;
        }
        
        // Get text content, filtering out any existing SVG elements
        let textContent = '';
        heading.childNodes.forEach(function(node) {
          if (node.nodeType === 3) { // Text node
            textContent += node.textContent;
          }
        });
        
        // Normalize the text - handle different quote types and whitespace
        const normalizedText = textContent.trim().replace(/[''""]/g, "'");
        
        // Check if heading contains "From the" and "Gram" (case insensitive)
        const lowerText = normalizedText.toLowerCase();
        if (lowerText.includes("from the") && lowerText.includes("gram")) {
          // Create Instagram SVG icon using the provided SVG
          const instagramIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          instagramIcon.setAttribute('class', 'instagram-icon-injected icon');
          instagramIcon.setAttribute('width', '24');
          instagramIcon.setAttribute('height', '24');
          instagramIcon.setAttribute('viewBox', '0 0 48 48');
          instagramIcon.setAttribute('aria-hidden', 'true');
          instagramIcon.setAttribute('focusable', 'false');
          instagramIcon.setAttribute('role', 'presentation');
          instagramIcon.style.display = 'inline-block';
          instagramIcon.style.verticalAlign = 'middle';
          instagramIcon.style.marginRight = '12px';
          instagramIcon.style.flexShrink = '0';
          instagramIcon.style.color = '#000';
          instagramIcon.style.position = 'relative';
          instagramIcon.style.top = '-0.075em';
          
          // Add the Instagram path
          const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', 'M24 0c-6.518 0-7.335.028-9.895.144-2.555.117-4.3.523-5.826 1.116-1.578.613-2.917 1.434-4.25 2.768C2.693 5.362 1.872 6.701 1.26 8.28.667 9.806.26 11.55.144 14.105.028 16.665 0 17.482 0 24s.028 7.335.144 9.895c.117 2.555.523 4.3 1.116 5.826.613 1.578 1.434 2.917 2.768 4.25 1.334 1.335 2.673 2.156 4.251 2.77 1.527.592 3.271.998 5.826 1.115 2.56.116 3.377.144 9.895.144s7.335-.028 9.895-.144c2.555-.117 4.3-.523 5.826-1.116 1.578-.613 2.917-1.434 4.25-2.768 1.335-1.334 2.156-2.673 2.77-4.251.592-1.527.998-3.271 1.115-5.826.116-2.56.144-3.377.144-9.895s-.028-7.335-.144-9.895c-.117-2.555-.523-4.3-1.116-5.826-.613-1.578-1.434-2.917-2.768-4.25-1.334-1.335-2.673-2.156-4.251-2.769-1.527-.593-3.271-1-5.826-1.116C31.335.028 30.518 0 24 0Zm0 4.324c6.408 0 7.167.025 9.698.14 2.34.107 3.61.498 4.457.827 1.12.435 1.92.955 2.759 1.795.84.84 1.36 1.64 1.795 2.76.33.845.72 2.116.827 4.456.115 2.53.14 3.29.14 9.698s-.025 7.167-.14 9.698c-.107 2.34-.498 3.61-.827 4.457-.435 1.12-.955 1.92-1.795 2.759-.84.84-1.64 1.36-2.76 1.795-.845.33-2.116.72-4.456.827-2.53.115-3.29.14-9.698.14-6.409 0-7.168-.025-9.698-.14-2.34-.107-3.61-.498-4.457-.827-1.12-.435-1.92-.955-2.759-1.795-.84-.84-1.36-1.64-1.795-2.76-.33-.845-.72-2.116-.827-4.456-.115-2.53-.14-3.29-.14-9.698s.025-7.167.14-9.698c.107-2.34.498-3.61.827-4.457.435-1.12.955-1.92 1.795-2.759.84-.84 1.64-1.36 2.76-1.795.845-.33 2.116-.72 4.456-.827 2.53-.115 3.29-.14 9.698-.14Zm0 7.352c-6.807 0-12.324 5.517-12.324 12.324 0 6.807 5.517 12.324 12.324 12.324 6.807 0 12.324-5.517 12.324-12.324 0-6.807-5.517-12.324-12.324-12.324ZM24 32a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm15.691-20.811a2.88 2.88 0 1 1-5.76 0 2.88 2.88 0 0 1 5.76 0Z');
          path.setAttribute('fill', 'currentColor');
          path.setAttribute('fill-rule', 'evenodd');
          
          instagramIcon.appendChild(path);
          
          // Insert icon at the beginning (left side) of the heading
          if (heading.firstChild) {
            heading.insertBefore(instagramIcon, heading.firstChild);
          } else {
            heading.appendChild(instagramIcon);
          }
        }
      });
    }
    
    // Run immediately
    injectInstagramIcon();
    
    // Also run after delays in case content loads dynamically
    setTimeout(injectInstagramIcon, 500);
    setTimeout(injectInstagramIcon, 1000);
    setTimeout(injectInstagramIcon, 2000);
    
    // Observe for DOM changes
    const observer = new MutationObserver(function(mutations) {
      injectInstagramIcon();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
